import {useRouter} from 'next/router';
import React, {createContext, useContext, useEffect, useMemo, useState, type PropsWithChildren} from 'react';

export interface State {
    searchTerm: string;
}

const initialState = {
    searchTerm: '',
};

export const SearchContext = createContext<State | any>(initialState);

SearchContext.displayName = 'SearchContext';

export const SearchProvider = ({children}: PropsWithChildren<{}>) => {
    const {query} = useRouter();
    const [searchTerm, updateSearchTerm] = useState('');

    useEffect(() => {
        if (query?.text) {
            updateSearchTerm(query?.text as string);
        } else {
            updateSearchTerm('');
        }
    }, [query]);

    const value = useMemo(
        () => ({
            searchTerm,
            updateSearchTerm,
        }),
        [searchTerm],
    );

    return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};

export const useSearch = () => {
    const context = useContext(SearchContext);
    if (context === undefined) {
        throw new Error(`useSearch must be used within a SearchProvider`);
    }
    return context;
};
